import { ViewIds } from '@ardoq/api-types';
import { DropdownOptionType } from '@ardoq/dropdown-menu';
import { markdownToTextPreview } from '@ardoq/markdown';
import { StatusType, Tag } from '@ardoq/status-ui';
import { ViewStyleThumbnail } from './ViewStyleThumbnail';

type ViewpointDropdownOptionBase = {
  name: string;
  viewName: ViewIds;
  description?: string | null;
  isDefaultOverview: boolean;
};

const toViewpointDropdownOption = (
  {
    name,
    viewName,
    description,
    isDefaultOverview,
  }: ViewpointDropdownOptionBase,
  defaultOverviewLabel: string
) => ({
  type: DropdownOptionType.OPTION as const,
  label: name,
  description: description ? markdownToTextPreview(description) : undefined,
  truncateDescription: true,
  leftContent: <ViewStyleThumbnail viewId={viewName} fit="viewBox" />,
  rightContent: isDefaultOverview ? (
    <Tag statusType={StatusType.DEFAULT} label={defaultOverviewLabel} />
  ) : undefined,
});

export { toViewpointDropdownOption };
